import React from "react"

import whatsapp from "./../../../UI/Modal/whatsapp.svg"
import address from "./../../../UI/Modal/location.svg"
import waze from "./../../../UI/Modal/waze.svg"
import phones from './../../../UI/Modal/phone.svg'

import googleMaps from './../../../UI/general/Google.svg'

import mail from './../../../UI/general/Mail.svg'

import close from "./../../../UI/general/close_white.svg"

interface Props{
    isContactModalOpened: boolean,
    logoConstructora: string,
    colorsData: any
    contactData: any,
    handleCloseContactModal: any
}

interface State{
    name: string,
    phone: string,
    email: string,
    message: string,
    hasWhatsapp: boolean
    whatsapp: string
}

class ContactModal extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            name: "",
            phone: "",
            email: "",
            message: "",
            hasWhatsapp: false,
            whatsapp: ""
        }
    }

    handleSentEmail = async() => {
        let details = {
            "name":this.state.name,
            "phone":this.state.phone,
            "email": this.state.email,
            "message": this.state.message
        }

        let response = await fetch("http://localhost:8080/contacto", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(details),
        })

        if(response.status === 200 ){
            this.setState({
                name: "",
                phone: "",
                email: "",
                message: ""
            })
        }
    }

    componentDidMount(): void {
        this.props.contactData.map((sala: any) => 
            sala.phones.map((phone: any) => {
                if(phone.whatsapp){
                    this.setState({
                        hasWhatsapp: true,
                        whatsapp: 'https://wa.me/'+phone.number.replace('+','')
                    })
                }
                return 0
            })
        )
    }

    render(): React.ReactNode {
        return(
            <div 
                className={this.props.isContactModalOpened ? "contact-modal fade-in":"contact-modal fade-out"}
            >
                <div
                    className="contact-form-info-container"
                >
                    <div className="contact-from-container">
                        <div className="contact-form-title">
                            Déjanos un mensaje y un asesor se pondrá en contacto contigo.
                        </div>
                        <div className="contact-form-input-container">
                            <input 
                                type="text" 
                                placeholder="Nombre" 
                                className="name-input"
                                onChange = {(e: any) => {this.setState({name: e.target.value})}}
                                value = {this.state.name}
                            />
                            <input 
                                type="number" 
                                placeholder="Teléfono" 
                                className="phone-input"
                                onChange = {(e: any) => {this.setState({phone: e.target.value})}}
                                value = {this.state.phone}
                            />
                            <input 
                                type="email" 
                                placeholder="Correo electrónico" 
                                className="email-input"
                                onChange = {(e: any) => {this.setState({email: e.target.value})}}
                                value = {this.state.email}
                            />
                            <textarea 
                                rows={4} 
                                cols={50}
                                placeholder="Mensaje" 
                                style={{resize: "none"}} 
                                className="message-input"
                                onChange = {(e: any) => {this.setState({message: e.target.value})}}
                                value = {this.state.message}
                            />
                        </div>
                        <div 
                            className="send-btn-form" 
                            style={{backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""}}
                            onClick = {() => {this.handleSentEmail()}}
                            data-type={"CONTACTO"}
                            data-value={"ENVIADO"}
                        >
                            ENVIAR
                        </div>
                    </div>
                    <div className="contact-info-container">
                        <div 
                            className="contact-info-close-btn"
                            style={{backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""}}
                            onClick = {() => {this.props.handleCloseContactModal()}}
                        >
                            <img src={close} alt=""/>
                        </div>
                        <div className="contact-info-logo-container">
                            <img src={"https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"+this.props.logoConstructora} alt=""></img>
                        </div>
                        <div className="contact-info-individual-container">
                            {
                                this.props.contactData ?
                                this.props.contactData.map((sala: any, index: number) => 
                                    <div className="sala-individual-container" key={sala.name + index}>
                                        <div className="sala-individual-title">{sala.name.toUpperCase()}</div>
                                        <div className="sala-individual-address">
                                            <img src={address} alt=""/>
                                            <div className="sala-addres-container">
                                                <div className="sala-individual-address-info">{sala.location}</div>
                                            </div>
                                        </div>
                                        {
                                            sala.hours.length > 0 ? 
                                            <div className="sala-individual-hours">
                                                <div className="sala-individual-hours-title">Horario de atención:</div>
                                                {
                                                    sala.hours.map((hour: any) => 
                                                        <div className="sala-individuañ-hours-container">
                                                            <div>{hour.dias}</div>
                                                            <div>{hour.hour_from} a {hour.hour_to}</div>
                                                        </div>
                                                    )
                                                }
                                            </div>:null
                                        }
                                        {
                                            sala.emails.length > 0 ?
                                            <div className="sala-phones-container" style={{marginTop: '1rem'}}>
                                                <div className="sala-phones-image-container">
                                                    <img src={mail} alt=""></img>
                                                </div>
                                                <div className="phone-container">
                                                {
                                                    sala.emails.map((email: any) => {
                                                        return(
                                                           <div style={{marginBottom: '0.5rem',marginTop: '0.5rem'}}>
                                                            {email.email}
                                                           </div>
                                                                
                                                            
                                                        )
                                                    })
                                                }
                                                </div>
                                            </div>:null
                                        }
                                        {
                                            sala.URLWaze !== "" ?
                                            <div className="sala-individual-waze">
                                                <img src={waze} alt=""></img>
                                                <a href={sala.URLWaze} target="_blank" rel="noreferrer">
                                                    Planea cómo llegar - Waze
                                                </a>
                                            </div>:null
                                        }
                                         {
                                            sala.URLMaps !== "" ?
                                            <div className="sala-individual-waze">
                                                <img src={googleMaps} alt=""></img>
                                                <a href={sala.URLMaps} target="_blank" rel="noreferrer">
                                                    Planea cómo llegar - Google Maps
                                                </a>
                                            </div>:null
                                        }
                                        {
                                            <div className="sala-phones-container" style={{marginTop: '1rem'}}>
                                                <div className="sala-phones-image-container">
                                                    <img src={phones} alt=""></img>
                                                </div>
                                                <div className="phone-container">
                                                {
                                                    sala.phones.map((phone: any) => {
                                                        return(
                                                           <div style={{marginBottom: '0.5rem',marginTop: '0.5rem'}}>
                                                            {
                                                                    phone.whatsapp === "true" ?
                                                                    <a href={'https://wa.me/'+phone.number.replace('+','')}>{phone.number.slice(0,3)+' '+phone.number.slice(3)}</a>:
                                                                    phone.number.slice(0,3)+' '+phone.number.slice(3)
                                                                }
                                                           </div>
                                                                
                                                            
                                                        )
                                                    })
                                                }
                                                </div>
                                            </div>
                                        }
                                        <br></br>
                                    </div>
                                ):null
                            }
                        </div>
                        {
                            this.state.hasWhatsapp ?
                            <a href={this.state.whatsapp} target="_blank" rel="noreferrer">
                                <div className="contact-info-wha-btn" style={{backgroundColor: this.props.colorsData ? this.props.colorsData.main_buttons:""}}>
                                    <img src={whatsapp} alt=""></img>
                                    <div className="whats-btn-title-container">
                                        <p className="whats-btn-title">Escribe a nuestro</p>
                                        <p className="whats-btn-text">WHATSAPP</p>
                                    </div>
                                </div>
                            </a>:null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default ContactModal